export const defaultToastDuration = 3000;
